/**
 * Validação do popup de newsletter (ticket 6f06f646)
 *
 * Problema corrigido: o campo de e-mail tinha apenas aria-required (marcação de
 * acessibilidade, sem efeito de validação). O formulário podia ser enviado em
 * branco, o listener de submit de halo-newsletter-popup.js fechava o popup e
 * gravava o cookie de exibição, e a visitante via a confirmação sem ter sido
 * cadastrada — além de perder o popup pelo período do cookie.
 *
 * Revisão: bloquear também domínios com erro de digitação conhecido
 * (ex.: gmial.com), que são estruturalmente válidos e por isso passavam.
 *
 * Arquivo próprio: a lição da loja proíbe concentrar lógica nova em arquivos
 * halo-* (tema base).
 *
 * WhatsApp e data de aniversário continuam opcionais por decisão do cliente.
 */
(function () {
    'use strict';

    var FORM_ID = 'ContactPopup';
    var EMAIL_ID = 'NewsletterForm--Popup';
    var ERRO_ID = 'newsletterEmailError';

    // Mais estrita que a validação nativa de type="email", que aceita "a@b".
    var EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

    var MSG_VAZIO = 'Informe seu e-mail para continuar.';
    var MSG_INVALIDO = 'E-mail inválido. Confira o endereço digitado (exemplo: nome@email.com).';

    // Domínios digitados errado com mais frequência -> domínio correto.
    // Pelo mesmo motivo que .co/.cm/.om ficam fora da regra genérica abaixo,
    // domínios que EXISTEM de verdade não entram aqui: ig.com (IG Group),
    // bol.com (loja holandesa) e terra.com são registrados e resolvem, então
    // bloqueá-los deixaria uma visitante com e-mail corporativo legítimo sem
    // nenhuma forma de se cadastrar. Só os erros de digitação inequívocos
    // ficam (tera.com.br, terra.co.br, bol.co.br, uol.co.br).
    var DOMINIOS_ERRADOS = {
        'gmai.com': 'gmail.com',
        'gmial.com': 'gmail.com',
        'gmal.com': 'gmail.com',
        'gmil.com': 'gmail.com',
        'gmali.com': 'gmail.com',
        'gamil.com': 'gmail.com',
        'gnail.com': 'gmail.com',
        'gmaill.com': 'gmail.com',
        'gmeil.com': 'gmail.com',
        'g-mail.com': 'gmail.com',
        'gmail.co': 'gmail.com',
        'gmail.cm': 'gmail.com',
        'gmail.om': 'gmail.com',
        'gmail.br': 'gmail.com',
        'gmail.com.br': 'gmail.com',
        'hotmai.com': 'hotmail.com',
        'hotmal.com': 'hotmail.com',
        'hotmial.com': 'hotmail.com',
        'hotmil.com': 'hotmail.com',
        'hotmali.com': 'hotmail.com',
        'hotmaill.com': 'hotmail.com',
        'hotmail.co': 'hotmail.com',
        'hotmail.cm': 'hotmail.com',
        'hotmail.om': 'hotmail.com',
        'hotmai.com.br': 'hotmail.com.br',
        'hotmal.com.br': 'hotmail.com.br',
        'hotmial.com.br': 'hotmail.com.br',
        'outlok.com': 'outlook.com',
        'outllok.com': 'outlook.com',
        'outook.com': 'outlook.com',
        'oulook.com': 'outlook.com',
        'outloock.com': 'outlook.com',
        'outlook.co': 'outlook.com',
        'outlook.cm': 'outlook.com',
        'outlok.com.br': 'outlook.com.br',
        'yaho.com': 'yahoo.com',
        'yahooo.com': 'yahoo.com',
        'yaoo.com': 'yahoo.com',
        'yahoo.co': 'yahoo.com',
        'yaho.com.br': 'yahoo.com.br',
        'yahooo.com.br': 'yahoo.com.br',
        'iclould.com': 'icloud.com',
        'icoud.com': 'icloud.com',
        'iclod.com': 'icloud.com',
        'icloud.co': 'icloud.com',
        'uol.com': 'uol.com.br',
        'uol.co.br': 'uol.com.br',
        'bol.co.br': 'bol.com.br',
        'tera.com.br': 'terra.com.br',
        'terra.co.br': 'terra.com.br',
        'globo.co': 'globo.com'
    };

    // Finais de domínio que não existem -> final correto.
    // .co, .cm e .om ficam FORA desta regra: são domínios reais e bloqueá-los
    // barraria e-mail corporativo legítimo. Só caem no mapa exato acima.
    var FINAIS_ERRADOS = [
        ['.con.br', '.com.br'],
        ['.com.b', '.com.br'],
        ['.con', '.com'],
        ['.cmo', '.com'],
        ['.ocm', '.com'],
        ['.coom', '.com'],
        ['.comm', '.com'],
        ['.vom', '.com'],
        ['.xom', '.com'],
        ['.cpm', '.com'],
        ['.clm', '.com']
    ];

    function campoEmail(form) {
        return (form && form.querySelector('#' + EMAIL_ID)) || document.getElementById(EMAIL_ID);
    }

    // A caixa entra DEPOIS do .form-field, nunca dentro dele: aquele bloco e
    // display:flex/row, e um filho novo ali virava uma segunda coluna ao lado
    // do campo -- medido no preview, o input caia de 260px para 113px e a
    // mensagem ficava comprimida do lado. Fora dele o pai e display:block, e a
    // mensagem cai embaixo, em largura cheia.
    function caixaErro(campo) {
        if (!campo) return null;

        var existente = document.getElementById(ERRO_ID);
        if (existente) return existente;

        var bloco = campo.closest ? campo.closest('.form-field') : null;
        var ancora = bloco || campo;
        var destino = ancora.parentNode;
        if (!destino) return null;

        var caixa = document.createElement('div');
        caixa.id = ERRO_ID;
        caixa.setAttribute('aria-live', 'polite');
        caixa.style.color = '#d32f2f';
        caixa.style.fontSize = '12px';
        caixa.style.marginTop = '5px';
        caixa.style.width = '100%';
        caixa.style.display = 'none';
        destino.insertBefore(caixa, ancora.nextSibling);
        return caixa;
    }

    // Devolve o endereço corrigido quando o domínio digitado for um erro
    // conhecido; null quando não houver suspeita.
    function sugestao(valor) {
        var corte = valor.lastIndexOf('@');
        if (corte < 1) return null;

        var local = valor.slice(0, corte);
        var dominio = valor.slice(corte + 1).toLowerCase();
        if (!local || !dominio) return null;

        if (Object.prototype.hasOwnProperty.call(DOMINIOS_ERRADOS, dominio)) {
            return local + '@' + DOMINIOS_ERRADOS[dominio];
        }

        for (var i = 0; i < FINAIS_ERRADOS.length; i++) {
            var fim = FINAIS_ERRADOS[i][0];
            if (dominio.length > fim.length && dominio.slice(-fim.length) === fim) {
                return local + '@' + dominio.slice(0, dominio.length - fim.length) + FINAIS_ERRADOS[i][1];
            }
        }

        return null;
    }

    // Devolve a mensagem de erro, ou null quando o e-mail está aceitável.
    function problema(valor) {
        if (valor === '') return MSG_VAZIO;
        if (!EMAIL_RE.test(valor)) return MSG_INVALIDO;

        var corrigido = sugestao(valor);
        if (corrigido) return 'E-mail inválido. Você quis dizer ' + corrigido + '?';

        return null;
    }

    function mostrarErro(campo, texto) {
        var caixa = caixaErro(campo);
        if (!caixa) return;
        caixa.textContent = texto;
        caixa.style.display = 'block';
        if (campo) campo.setAttribute('aria-invalid', 'true');
    }

    function limparErro(campo) {
        // Busca por id, nao pelo pai: a caixa nao mora mais dentro do .form-field.
        var caixa = document.getElementById(ERRO_ID);
        if (caixa) {
            caixa.textContent = '';
            caixa.style.display = 'none';
        }
        if (campo) campo.removeAttribute('aria-invalid');
    }

    // Preparação do formulário: obrigatoriedade nativa + caixa de aviso.
    // Continua valendo mesmo que o restante do script falhe, porque o atributo
    // required sozinho já impede o envio em branco.
    function prepararFormulario() {
        var form = document.getElementById(FORM_ID);
        if (!form || form.getAttribute('data-validacao-email') === 'ativa') return;

        var campo = campoEmail(form);
        if (!campo) return;

        form.setAttribute('data-validacao-email', 'ativa');
        campo.setAttribute('required', 'required');

        caixaErro(campo);

        campo.addEventListener('input', function () {
            limparErro(campo);
        });

        // Aviso antecipado: ao sair do campo, sem esperar o clique no botão.
        campo.addEventListener('blur', function () {
            var valor = campo.value.trim();
            if (valor === '') return;
            var aviso = problema(valor);
            if (aviso) mostrarErro(campo, aviso);
        });

        // Disparado quando a validação nativa reprova o campo: exibe o aviso
        // em tela junto da mensagem padrão do navegador.
        campo.addEventListener('invalid', function () {
            mostrarErro(campo, problema(campo.value.trim()) || MSG_INVALIDO);
        });
    }

    // Guarda global em fase de CAPTURA: roda antes dos listeners de submit
    // registrados no próprio formulário (halo-newsletter-popup.js e o script
    // inline do snippet), de modo que um envio inválido não fecha o popup nem
    // grava o cookie de exibição.
    function registrarGuarda() {
        if (document.documentElement.getAttribute('data-guarda-newsletter') === 'ativa') return;
        document.documentElement.setAttribute('data-guarda-newsletter', 'ativa');

        document.addEventListener('submit', function (event) {
            var form = event.target;
            if (!form || form.id !== FORM_ID) return;

            var campo = campoEmail(form);
            if (!campo) return;

            var valor = campo.value.trim();
            var aviso = problema(valor);

            if (!aviso) {
                limparErro(campo);
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            mostrarErro(campo, aviso);

            try {
                campo.focus();
            } catch (e) {}
        }, true);
    }

    function iniciar() {
        registrarGuarda();
        prepararFormulario();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', iniciar);
    } else {
        iniciar();
    }

    // Reaplica quando o editor de tema recarrega a seção.
    document.addEventListener('shopify:section:load', prepararFormulario);
})();
